import client from '@/graphql/client'
import GetJiraIssues2 from '@/graphql/queries/GetJiraIssues2'

// Cleared workflow state can pass `undefined`, which serializes to the literal
// string "undefined" and is rejected by the backend as "Not authorized for this
// project". Skip the query when an id is not a real, non-empty string.
const isUsableId = (v) => typeof v === 'string' && v.length > 0 && v !== 'undefined' && v !== 'null'

export const jira = {
  namespaced: true,
  state: {
    jiraIssues: null
  },
  mutations: {
    setJiraIssues (state, payload) {
      state.jiraIssues = payload
    }
  },
  actions: {
    async getJiraIssues ({ commit }, { projectId, workflowId, apiToken }) {
      if (!isUsableId(projectId) || !isUsableId(workflowId)) {
        return
      }
      const res = await client.query({
        operationName: 'getJiraIssues2',
        query: GetJiraIssues2,
        variables: {
          projectId,
          workflowId,
          apiToken
        }
      }, {
        failSilently: true
      })
      commit('setJiraIssues', res?.getJiraIssues2)
      return res
    }
  }
}
